// extracted by mini-css-extract-plugin
export default {"container":"y0-z","heading":"z0-z","links":"A0-z","copy":"B0-z","subCopy":"C0-z","linksLeft":"D0-z","linksCenter":"E0-z","linksRight":"F0-z","link":"G0-z","onlyLink":"H0-z"};